import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserLock } from "@fortawesome/free-solid-svg-icons"

export const UserLock = (props) => {
  return <FontAwesomeIcon faIcon={faUserLock} {...props} />
}
